// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Importing main pages
import HomePage from "./HomePage";
import Managers from "./Managers";
import Seasons from "./Seasons";
import LeagueSettings from "./LeagueSettings";

// Importing manager sites
import ChrisBode from "./managerSites/chrisbode";
import DaveCriss from "./managerSites/davecriss";
import DerekColeman from "./managerSites/derekcoleman";
import JosephHuynh from "./managerSites/josephhuynh";
import JoshBoland from "./managerSites/joshboland";
import JosueAmi from "./managerSites/josueami";
import LindsayCagarli from "./managerSites/lindsaycagarli";
import MaxSnow from "./managerSites/maxsnow";
import NickCriss from "./managerSites/nickcriss";
import ShahdadParsi from "./managerSites/shahdadparsi";


function App() {
  return (
    <Router>
      <Routes>
        {/* Main routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/managers" element={<Managers />} />
        <Route path="/seasons" element={<Seasons />} />
        <Route path="/league-settings" element={<LeagueSettings />} />

        {/* Manager specific routes */}
        <Route path="/managers/chrisbode" element={<ChrisBode />} />
        <Route path="/managers/davecriss" element={<DaveCriss />} />
        <Route path="/managers/derekcoleman" element={<DerekColeman />} />
        <Route path="/managers/josephhuynh" element={<JosephHuynh />} />
        <Route path="/managers/joshboland" element={<JoshBoland />} />
        <Route path="/managers/josueami" element={<JosueAmi />} />
        <Route path="/managers/lindsaycagarli" element={<LindsayCagarli />} />
        <Route path="/managers/maxsnow" element={<MaxSnow />} />
        <Route path="/managers/nickcriss" element={<NickCriss />} />
        <Route path="/managers/shahdadparsi" element={<ShahdadParsi />} />
      </Routes>
    </Router>
  );
}

// Exporting the App component
export default App;
